/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2022, 2023
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Rave2bundletiledmap {
		get config(){
			return {
				'type':'Tiledmap',
				'doesNotSupportCustomGroupAction': true,
				'cursor': ['grab', '-moz-grab', '-webkit-grab'],
				'renderWithoutCompletingMapping':true,
				'geo': true,
				'supportsLayers': true,
				'thumbnail': {
					'enabled': false,
					'type': 'img'
				},
				'listenForPropChanges': [
					'region.visible',
					'point.visible',
					'latLong.visible',
					'widget.legend.size'
				],
				'propertiesToSetBeforeData': [
					'widget.data.truncate',
					'point.custom.mapId',
					'point.custom.layerName',
					'point.custom.propertyName',
					'region.custom.mapId',
					'region.custom.layerName',
					'region.custom.propertyName'
				],
				'layerDescriptions':[
					{
						id: 'data.region',
						colorRelatedProps: {
							transparencyProp: 'region.transparency',
							defaultPaletteValue: 'colorPalette0',
							sectionNameId: 'sectionName_regionLayer'
						},
						visibleLayerProps: [
							'region.grouping.mode',
							'region.grouping.heat.weight',
							'region.custom.mapId',
							'region.custom.layerName',
							'region.custom.propertyName'
						]
					},
					{
						id: 'data.point',
						colorRelatedProps: {
							transparencyProp: 'point.transparency',
							defaultPaletteValue: 'colorPalette1',
							sectionNameId: 'sectionName_pointLayer'
						},
						visibleLayerProps: [
							'point.grouping.mode',
							'point.grouping.heat.weight',
							'point.custom.mapId',
							'point.custom.layerName',
							'point.custom.propertyName'
						]
					},
					{
						id: 'data.latlong',
						colorRelatedProps: {
							transparencyProp: 'latLong.transparency',
							defaultPaletteValue: 'colorPalette2',
							sectionNameId: 'sectionName_latLongLayer'
						},
						visibleLayerProps: [
							'latLong.grouping.mode',
							'latLong.grouping.heat.weight'
						]
					}
				],
				//'isActivated':PropertiesHelper.isTiledMapActivated,
				//'getProperitesFromGlobalConfig':      PropertiesHelper.getTiledMapGlobalConfigProperties
				'dataRowLimit':30000,
				'dataRowLimitIE':3000,
				'slots':{
					'locations':{
						'subtype':'location',
						'icon':'location'
					},
					'locationColor':{
						'icon':'heat_map',
						'mldTitleProperty': 'locationColor.title',
						'tags': ['canUseToColor']
					},
					'pointLocations':{
						'icon':'location',
						'subtype':'location'
					},
					'pointSize':{
						'icon':'size_by',
						'mldTitleProperty': 'pointSize.title'
					},
					'pointColor':{
						'icon':'point_heat',
						'mldTitleProperty': 'pointColor.title',
						'tags': ['canUseToColor']
					},
					'latlongLocations.latitude':{
						'subtype':'latitude',
						'useCategoryAsValue':true,
						'icon':'location'
					},
					'latlongLocations.longitude':{
						'subtype':'longitude',
						'useCategoryAsValue':true,
						'icon':'location'
					},
					'latlongLocations.caption':{
						'icon':'text'
					},
					'latlongSize':{
						'icon':'size_by',
						'mldTitleProperty': 'latlongSize.title'
					},
					'latlongColor':{
						'icon':'point_heat',
						'mldTitleProperty': 'latlongColor.title',
						'tags': ['canUseToColor']
					}
				},
				'propertyPrefixes': {
					'locationColor': 'widget.legend',
					'pointColor': 'widget.legend',
					'latlongColor': 'widget.legend',
					'pointSize': 'widget.legend'
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont']
				},
				'properties':{
					'locationColor.title': {
						'multilingual': true
					},
					'pointSize.title': {
						'multilingual': true
					},
					'pointColor.title': {
						'multilingual': true
					},
					'latlongSize.title': {
						'multilingual': true
					},
					'latlongColor.title': {
						'multilingual': true
					},
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'region.visible': {
						active: false
					},
					'point.visible': {
						active: false
					},
					'latLong.visible': {
						active: false
					},
					'format.compact':{
						'active':false
					},
					'legendPosition':{
						'active':false
					},
					'legend.display':{
						'active':false
					},
					'latLong.defaultSize':{
						'active': false,
						'defaultValue':8,
						'isReadOnly': true
					},
					'point.defaultSize': {
						'active': false,
						'defaultValue': 8,
						'isReadOnly': true
					},
					'preserveDrawingBuffer': {
						'defaultValue': true
					},
					'maxZoom': {
						'active': false
					},
					'region.transparency': {
						'active': false
					},
					'point.minSize': {
						'active': false
					},
					'point.maxSize': {
						'active': false
					},
					'point.transparency': {
						'active': false
					},
					'point.staticZeroValueSize': {
						'active': false
					},
					'point.grouping.transition': {
						'active': false
					},
					'point.grouping.cluster.radius': {
						'active': false
					},
					'point.grouping.cluster.groups': {
						'active': false
					},
					'latLong.minSize': {
						'active': false
					},
					'latLong.maxSize': {
						'active': false
					},
					'latLong.transparency': {
						'active': false
					},
					'latLong.staticZeroValueSize': {
						'active': false
					},
					'latLong.grouping.transition': {
						'active': false
					},
					'latLong.grouping.cluster.radius': {
						'active': false
					},
					'latLong.grouping.cluster.groups': {
						'active': false
					},
					'Mapbox.accountName':{
						'active':false
					},
					'Mapbox.token':{
						'active':false
					},
					'widget.legend.size': {
						'active': false
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'region.minHeight': {
						percentage: false
					},
					'region.maxHeight': {
						percentage: false
					},
					'point.grouping.hexbin.minExtrudeHeight': {
						percentage: false
					},
					'point.grouping.hexbin.maxExtrudeHeight': {
						percentage: false
					},
					'point.grouping.hexbin.radius': {
						percentage: false
					},
					'latLong.grouping.hexbin.minExtrudeHeight': {
						percentage: false
					},
					'latLong.grouping.hexbin.maxExtrudeHeight': {
						percentage: false
					},
					'latLong.grouping.hexbin.radius': {
						percentage: false
					}
				},
				config:{
					'include':[
						'widget.data.truncate',
						'widget.iterator',
						'widget.legend.display',
						'widget.legend.position',
						'map.style.2',
						'map.style.url',
						'Mapbox.worldView',
						'autoZoom',
						'maxZoom',
						'values.null.color',
						'enableLayerControl',
						'enableFeatureSearchControl',
						'region.visible',
						'region.transparency',
						'region.minHeight',
						'region.maxHeight',
						'region.custom.mapId',
						'region.custom.layerName',
						'region.custom.propertyName',
						'point.visible',
						'point.defaultSize',
						'point.minSize',
						'point.maxSize',
						'point.transparency',
						'point.staticZeroValueSize',
						'point.custom.mapId',
						'point.custom.layerName',
						'point.custom.propertyName',
						'point.grouping.mode',
						'point.grouping.transition',
						'point.grouping.heat.weight',
						'point.grouping.cluster.radius',
						'point.grouping.cluster.groups',
						'point.grouping.hexbin.radius',
						'point.grouping.hexbin.minExtrudeHeight',
						'point.grouping.hexbin.maxExtrudeHeight',
						'latLong.defaultSize',
						'latLong.visible',
						'latLong.minSize',
						'latLong.maxSize',
						'latLong.transparency',
						'latLong.staticZeroValueSize',
						'latLong.grouping.mode',
						'latLong.grouping.transition',
						'latLong.grouping.heat.weight',
						'latLong.grouping.cluster.radius',
						'latLong.grouping.cluster.groups',
						'latLong.grouping.hexbin.radius',
						'latLong.grouping.hexbin.minExtrudeHeight',
						'latLong.grouping.hexbin.maxExtrudeHeight',
						'Mapbox.accountName',
						'Mapbox.token',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleColor',
						'widget.legend.titleFont',
						'widget.legend.swatch.symbol.default',
						'interactivityState',
						'locationColor',
						'locationColorCat',
						'pointColor',
						'pointColorCat',
						'latlongColor',
						'latlongColorCat',
						'widget.legend.size',
						'widget.legend.titleVisible',
						'locationColor.title',
						'pointSize.title',
						'pointColor.title',
						'latlongSize.title',
						'latlongColor.title',
						'optimizeSize',
						'mapLabels.localLanguage'
					],
					'exclude':[
					]
				},
				'usages':[
					'Geospatial'
				],
				'supportsMaintainAxisScale': true,
				'ignoreElementColor': true,
				'isMultilayersWidget': true,
				'requiredConfig':['Mapbox.accountName','Mapbox.token']
			};
		}
	}
	return Rave2bundletiledmap;
});
